import {
  ToggleGroup,
  ToggleGroupItem,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@pdfking/components"
import { BookOpenIcon, Columns2Icon, SquareIcon } from "lucide-react"

import type { PageGrouping } from "#public"

import { useTranslationTyped } from "../i18n/useTranslation"
import { TOGGLE_BUTTON_CLASS } from "./ToggleButtonClass"

// The flat plot's page-pairing picker — a segmented control mirroring the
// BLEED/stripe toggles' icon-plus-tooltip style. 2D-only, so it lives in the
// PlotViewer header rather than the shared host controls.
const OPTIONS = [
  { icon: SquareIcon, key: "GROUP_SINGLE", value: "single" },
  { icon: BookOpenIcon, key: "GROUP_COVER", value: "cover" },
  { icon: Columns2Icon, key: "GROUP_DOUBLE", value: "double" },
] as const

export function PageGroupingControl({
  value,
  on_value,
}: {
  value: PageGrouping
  on_value: (grouping: PageGrouping) => void
}) {
  const pdfview = useTranslationTyped("pdfview")
  return (
    <ToggleGroup
      onValueChange={next => next && on_value(next as PageGrouping)}
      size="sm"
      type="single"
      value={value}
    >
      {OPTIONS.map(({ icon: Icon, key, value: option }) => {
        const label = pdfview[key]()
        return (
          <Tooltip key={option}>
            <TooltipTrigger asChild>
              <span className="inline-flex">
                <ToggleGroupItem aria-label={label} className={TOGGLE_BUTTON_CLASS} value={option}>
                  <Icon className="size-4" />
                </ToggleGroupItem>
              </span>
            </TooltipTrigger>
            {/* Downwards — a header control, same as ToggleButton's. */}
            <TooltipContent side="bottom">{label}</TooltipContent>
          </Tooltip>
        )
      })}
    </ToggleGroup>
  )
}
